module.exports = __webpack_public_path__ + "static/media/logo.16cd5e7e.png";